import { cn } from '@/lib/utils';
import { type CouleurNoyau, NOYAUX, type NoyauCode } from '@rosetta/shared';
import { styleNoyau } from './noyaux-affichage';

interface PastilleCodeNoyauProps {
  noyau: NoyauCode;
}

/** Colour of the code on each noyau, as on the mockups: black on the light colours. */
const ENCRE: Record<CouleurNoyau, string> = {
  'bleu-nuit': 'text-white',
  'bleu-ciel': 'text-black',
  vert: 'text-black',
  jaune: 'text-black',
  rouge: 'text-white',
  rose: 'text-white',
};

/**
 * The code of a noyau in a pill of its colour ("GSP"), as in the header of the
 * analysis. Shared by the analysis header and the waiting screen ("Voir aussi"); the round dot of `pastille-noyau.tsx` has no code.
 */
export function PastilleCodeNoyau({ noyau }: PastilleCodeNoyauProps) {
  return (
    <span
      className={cn(
        'rounded-full px-2 font-bold text-micro leading-[18px] tracking-[1px]',
        styleNoyau(noyau).pastille,
        ENCRE[NOYAUX[noyau].couleur],
      )}
    >
      {noyau}
    </span>
  );
}
